import { Link } from 'react-router';
import { Icon } from '@/app/kit';
import { uiCopy } from './copy';

/**
 * The one back control for a screen that sits under a tab root: chevron plus label, at least 44 px
 * tall, always the first thing in the screen. Keepers and recorders on the bare layout keep their
 * round icon button; everything else uses this.
 *
 *   <BackLink to="/tournaments">All tournaments</BackLink>
 */
export interface BackLinkProps {
  to: string;
  /** Defaults to "Back". */
  children?: string;
  className?: string;
}

export function BackLink({ to, children, className }: BackLinkProps) {
  return (
    <Link
      to={to}
      className={`inline-flex min-h-11 min-w-11 items-center gap-1 self-start font-bold underline decoration-3 underline-offset-4${className ? ` ${className}` : ''}`}
    >
      <Icon name="chevron" size={18} className="rotate-180" />
      <span>{children ?? uiCopy.back}</span>
    </Link>
  );
}
